<template>
    <section class="cards-list-list">
        <div class="inner">
            <h2 class="cards-list-list__title h2">{{ title }}</h2>
            <div class="list-body">
                <p v-for="part in bodyParts" :key="part">{{ part }}</p>
            </div>
            <div class="cards-list-list__list">
                <component
                    :is="listItemComponent"
                    v-for="card in cards"
                    :key="card.id"
                    :card
                />
            </div>
            <div v-if="hasButton" class="actions">
                <NuxtLink class="ds-btn ds-btn--primary" :to="buttonURL">
                    <DSIcon class="extra-icon" :code="layout?.button?.ctaIcon ?? 'arrow-right'" />
                    <span>{{ buttonText }}</span>
                    <DSIcon :code="layout?.button?.ctaIcon ?? 'arrow-right'" />
                </NuxtLink>
            </div>
        </div>
    </section>
</template>
<script setup>
import { inject } from '#imports';
import { computed, resolveComponent } from 'vue';

const props = defineProps({
    cards: {
        type: Array,
        required: false,
        default: () => [],
    },
    display: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    createdAt: {
        type: String,
        required: false,
        default: '',
    },
    updatedAt: {
        type: String,
        required: false,
        default: '',
    },
    id: {
        type: String,
        required: true,
    },
    contentType: {
        type: String,
        required: true,
    },
    internal: {
        type: String,
        required: false,
        default: '',
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
});
const title = computed(() => props.display.title);
const bodyParts = computed(() => props.display.body.split(/\r\n|\r|\n/));
const variation = computed(() => props.display.variation);
const buttonText = computed(() => props.display.buttontext);
const buttonURL = computed(() => props.display.buttonurl);
const hasButton = computed(() => buttonText.value.length && buttonURL.value.length);
const layout = inject('layout');
const listItemComponent = computed(() => {
    let component = resolveComponent('BlocksCLListItemDefault');
    switch (variation.value) {
        case 'link':
            component = resolveComponent('BlocksCLListItemLink');
            break;
        case 'downloadablecontent':
            component = resolveComponent('BlocksCLListItemDownloadableContent');
            break;
    }

    return component;
});
</script>
